import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { styleEntry } from '@mylighthouse/prism-ember';
import { and, not } from 'ember-truth-helpers';

import styles from './table-cell-wrapper.module.css';

interface HotelChannelPricingTablesCellsTableCellWrapperSignature {
  Args: {
    anchorName?: string;
    hasInteractions: boolean;
    hasOpenCta: boolean;
    hasRecommendation: boolean;
    id?: string;
    showException: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: Element;
}

const TableCellWrapper = <template>
  <div
    class="{{styles.channel-pricing-table-cell}}
      flex h-full w-full
      {{if
        (and @showException (not @hasInteractions))
        styles.channel-pricing-table-cell--has-exception
      }}"
    id={{@id}}
  >
    {{#if @hasInteractions}}
      {{! Button here gives keyboard navigation. Contributing to accessibility. }}
      {{! style sets the per-cell anchor-name the edit popover positions against. }}
      <button
        class="{{styles.cell-button}}
          button--unstyled h-full w-full
          {{if @showException styles.cell-button--has-exception}}
          {{if @hasOpenCta styles.cell-button--with-popover}}
          {{if
            (and @hasRecommendation (not @hasOpenCta) (not @showException))
            styles.cell-button--has-recommendation
          }}"
        style={{if
          @anchorName
          (styleEntry "anchor-name" (concat "--" @anchorName))
        }}
        type="button"
        {{! ...attributes stays last (sort-invocations lint). Trade-off: a caller-splatted style= would then override the anchor-name above; left as-is rather than add a lint-disable. }}
        ...attributes
      >
        {{yield}}
      </button>
    {{else}}
      <div
        class="flex h-full w-full items-center justify-end
          {{if @showException styles.channel-pricing-table-cell--has-exception}}
          {{if
            @hasRecommendation
            styles.channel-pricing-table-cell--has-recommendation
          }}"
        ...attributes
      >
        {{yield}}
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<HotelChannelPricingTablesCellsTableCellWrapperSignature>;

export default TableCellWrapper;
